import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import Navigation from 'hb-react/shared/apps/Memberships/containers/PurchaseMembership/components/Navigation';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/useShoppingCard';

const NavBarDesktop = ({
  onCancel,
  onNext,
  registrationSubmitButtonText,
  isNextDisabled = false,
}) => (
  <>
    <Button
      variant="secondary"
      mr={2}
      icon={() => (
        <FontAwesomeIcon
          iconName="chevron-left"
          height="16px"
          iconType={CATEGORIES.SOLID}
        />
      )}
      size="small"
      onClick={onCancel}
    >
      {s__('Memberships|Cancel purchase')}
    </Button>
    <Button onClick={onNext} isDisabled={isNextDisabled}>
      {registrationSubmitButtonText}
    </Button>
  </>
);

const NavBarMobile = ({ onCancel, onNext, isNextDisabled = false }) => (
  <Box flexDirection="column" width="100%" justifyContent="space-between">
    <Box alignSelf="flex-end">
      <Button variant="secondary" mr={2} onClick={onCancel}>
        {__('Back')}
      </Button>
      <Button onClick={onNext} isDisabled={isNextDisabled}>
        {s__('ShoppingCard|Proceed')}
      </Button>
    </Box>
  </Box>
);

export const NavBar = (props) => {
  const { isLoading } = useShoppingCard();

  return (
    <Navigation>
      {({ isFixed }) =>
        isFixed ? (
          <NavBarMobile {...props} isNextDisabled={isLoading} />
        ) : (
          <NavBarDesktop {...props} isNextDisabled={isLoading} />
        )
      }
    </Navigation>
  );
};
